/**
 * @format
 * @flow strict-local
 */
// DEPENDENCIES

import styled from "styled-components";

import {
	columnWrapper
} from "../../styled/styled-extends";

// EXPORT

export const ComponentWrapper = styled.div`
	align-items: center;
	gap: 16px;
	padding: 16px;
	width: 100%;
	${columnWrapper}

	.cardBody {
		gap: 24px;
	}

	.footerButton {
		width: 100%;
	}

	@media only screen and (min-width: 390px) {
	}

	@media only screen and (min-width: 576px) {
		gap: 16px;
		padding: 24px;
	}

	@media only screen and (min-width: 768px) {
		.card {
			width: 480px;
		}
	}

	@media only screen and (min-width: 1024px) {
		gap: 24px;
		padding: 32px;
	}

	@media only screen and (min-width: 1280px) {
		gap: 32px;
		padding: 40px;
	}

	@media only screen and (min-width: 1440px) {
		gap: 40px;
		padding: 48px;
	}

	${(props) => {
		const {
			body
		} = props.theme;

		let loaderWrapperOpacity = 0;
		let loaderWrapperPointerEvents = "none";

		if(props.loaderActive) {
			loaderWrapperOpacity = 1;
			loaderWrapperPointerEvents = "auto";
		}

		return `
			background-color: ${body.background};
		`;
	}};
`;
